import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { CentroCustoComponent } from './../centro-custo/centro-custo.component';
import { EnderecoService } from './../../../service/endereco/endereco.service';
import { CentroCustoService } from 'app/service/cliente/centro-custo.service';
import { EnderecoModel } from './../../../model/endereco/endereco.model';
import { CentroCustoModel } from './../../../model/cliente/centrocusto.model';
import { ActivatedRoute } from '@angular/router';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { AreaService } from 'app/service/cliente/area.service';
import { AreaModel } from '../../../model/cliente/area.model';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { UnidadeGestoraService } from 'app/service/cliente/unidade-gestora.service';
import { UnidadeGestoraModel } from 'app/model/cliente/unidadegestora';
import { DialogConfirmComponent } from 'app/components/dialog/dialog-confirm/dialog-confirm.component';


@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrls: ['./areas.component.scss']
})
export class AreasComponent implements OnInit {
  @ViewChild('categoryPaginator', { read: MatPaginator }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginatorArea: MatPaginator;
  @ViewChild(MatSort) sortArea: MatSort;
  paginatorLength = 0;
  @Input() clienteProp: ClienteModel;
  @Input() clientePropId: number;
  @Output() newItemEvent = new EventEmitter<string>();
  displayedColumnsUser = ['nome', 'acoes'];
  displayedColumnsArea = ['cod', 'nome', 'centro', 'status', 'acoes'];
  dataSource = new MatTableDataSource<any[]>([]);
  dataSourceArea = new MatTableDataSource<AreaModel>([]);
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  area = {} as AreaModel;
  areas: AreaModel[];
  usuarios: any[] = [];
  usuariosAuth: any[] = [];
  usuariosBD: any[] = [];
  loading = false;
  isChecked = false;
  areaReady = false;

  cliente = {} as ClienteModel;
  clientes: ClienteModel[];
  centroCusto = {} as CentroCustoModel;
  centroCustos: CentroCustoModel[];
  endereco = {} as EnderecoModel;
  enderecos: EnderecoModel[];
  unidadeGestora = {} as UnidadeGestoraModel;
  unidadeGestoras: UnidadeGestoraModel[];

  public submit = false;

  public formArea: FormGroup;

  private page: ResponsePageable;

  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;
  public messageError = false;
  mensagemErro;

  public arrayString: string;
  public creatorArea = false;
  public editorArea = false;
  public listaArea = false;
  public deletaArea = false;
  public superUser = false;

  public clienteId: any;
  public deData: any;

  constructor(
    public areaService: AreaService,
    public unidadeGestoraService: UnidadeGestoraService,
    public clienteService: ClienteService,
    public centroCustoService: CentroCustoService,
    public enderecoService: EnderecoService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private permissionService: PermissoesService) {
    this.route.params.subscribe(params => this.clienteId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
    this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.formArea = this.fb.group({
      codigo: [null, [Validators.maxLength(10), Validators.required]],
      descricao: [null, [Validators.maxLength(80)]],
      sigla: [null, [Validators.maxLength(6), Validators.required]],
      cliente: [null],
      usuarios: [null],
      unidadeGestora: [UnidadeGestoraModel, [Validators.required]],
      centroCusto: [CentroCustoModel, [Validators.required]],
      endereco: [EnderecoModel, [Validators.required]],
      tipoCadastroArea: [null, [Validators.required]],
      areaPadrao: [false],
      ativo: [false],
      codAutomatico: [false],
      dataDesativacao: [null],
      observacao: [null]
    });

    this.getAreasIdCliente(this.clienteId);
    this.getCentroCusto();
    this.getEnderecos();
    this.getUnidadeGestoras();
    this.getAuthority();
  }

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  setUserAuthorized(id: number) {
    console.log(id);
    const foundAuthorized = this.usuariosAuth.find(x => x.id === id);
    const found = this.usuarios.find(x => x.id === id);
    if (foundAuthorized != null) {
      console.error('error');
      this.openSnackBarError(`Usuário ${foundAuthorized.nome} já adicionado !`);
    } else {
      this.usuariosAuth.push(found);
    }
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  aplicarFiltrosArea(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSourceArea.filter = filter;
  }

  removeUserAuthorized(id: number) {
    const foundIndex = this.usuariosAuth.findIndex(x => x.id === id);
    const foundAuthorized = this.usuariosAuth.find(x => x.id === id);
    const found = this.usuarios.find(x => x.id === id);
    if (foundIndex > -1) {
      this.usuariosAuth.splice(foundIndex, 1);
    }
    if (found != null) {
      console.error('error');
    } else {
      this.usuarios.push(foundAuthorized);
    }
  }

  getEnderecos() {
    this.enderecoService.getEnderecosCliente(this.clienteId).subscribe(data => {
      this.enderecos = data;
    }, error => {
      console.error(error);
    });
  }

  getUnidadeGestoras() {
    this.unidadeGestoraService.getUnidadeGestoraIdCliente(this.clienteId).subscribe(data => {
      this.unidadeGestoras = data;
    }, error => {
      console.log(error);
    });
  }

  getUsuarios() {
    this.areaService.getUserAreas(this.clienteId).subscribe(data => {
      console.log(data);
      this.usuarios = data.map(element => ({ id: element.id, nome: element.nome }));
      console.log(this.usuarios);
      this.dataSource = new MatTableDataSource(this.usuarios);
      console.log(this.dataSource);
      this.dataSource.paginator = this.paginator;
      this.paginatorLength = this.usuarios.length;
      this.dataSource.sort = this.sort;
    }, err => {
      console.error(err);
    });
  }

  splicesArrays() {
    this.usuarios.forEach(element => {
      console.log(element);
    });
  }

  getUsuariosAreaBD(idArea: number) {
    this.areaService.getUsersArea(idArea).subscribe(data => {
      this.usuariosBD = data;
      this.getUsuarios();
      this.usuariosAuth = this.usuariosBD;
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  getCentroCusto() {
    this.centroCustoService.getListaCentroCustoNoPage().subscribe(data => {
      this.centroCustos = data.content;
    }, error => {
      console.error(error);
    });
  }

  openDialogCentroCusto() {
    const dialogRef = this.dialog.open(CentroCustoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  listarPageAreas(page, size) {
    this.areaService.getPageAreas(page, size).subscribe(res => {
      this.page = res;
      this.areas = this.page.content;
    });
    this.areaReady = true;
  }

  getAreasIdCliente(id: number) {
    this.areaService.getAreasIdCliente(id).subscribe(data => {
      this.areas = data;
      this.dataSourceArea = new MatTableDataSource(this.areas);
      console.log(this.dataSourceArea);
      this.dataSourceArea.paginator = this.paginatorArea;
      this.dataSourceArea.sort = this.sortArea;
    }, error => {
      console.error(error);
    });
  }

  compararEditArea(obj1, obj2) {
    return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
  }

  changePage(event) {
    this.listarPageAreas(event.page, event.size);
    this.pageAtual = event.page;
  }

  onSubmit() {
    this.submit = true;
  }

  postSubmit() {
    this.submit = false;
  }

  saveOrEditArea() {
    if (this.area.id !== undefined) {
      this.editArea();
    } else {
      if (this.formArea.valid) {
        this.adicionarArea();
      } else {
        this.openSnackBarError(`Preencha todos os campos obrigatórios!`);
      }
    }
  }

  adicionarArea() {
    this.formArea.get('cliente').setValue(this.clienteProp);
    this.formArea.get('usuarios').setValue(this.usuariosAuth);
    this.areaService.postArea(this.formArea.value, this.clienteId).subscribe(area => {
      this.area = new AreaModel();
      this.getAreasIdCliente(this.clientePropId);
      this.formArea.reset();
      // this.usuarios.splice(0, this.usuarios.length);
      this.usuariosAuth.splice(0, this.usuariosAuth.length);
      this.getUsuarios();
      this.openSnackBarSuccess('Área salva com sucesso !');
      this.postSubmit();
    }, error => {
      // console.log(error.status);
      if (error.status === 400) {
        this.mensagemErro = 'Preencha todos os campos obrigatórios!';
        this.openSnackBarError('Erro ao tentar salvar a Área !');
      } else {
        this.mensagemErro = error.error.message;
        if (this.mensagemErro === 'Área já criada com este código') {
          this.openSnackBarError(`Erro ao tentar salvar a Área ! ${this.mensagemErro}`);
        } else {
          this.openSnackBarError(`Erro ao tentar salvar a Área !`);
        }
      }

    });
  }

  editArea() {
    this.area.usuarios = this.usuariosAuth;
    // console.log(this.area);
    // this.formArea.get('usuarios').setValue(this.usuariosAuth);
    this.areaService.putArea(this.area, this.clienteId).subscribe(data => {
      this.getAreasIdCliente(this.clientePropId);
      this.openSnackBarSuccess('Área atualizada com sucesso !');
    }, err => {
      this.mensagemErro = err.error.message;
      this.openSnackBarError(`Erro ao tentar atualizar a Área !`);
    });
  }


  clickNovaArea() {
    this.area.id = undefined;
    this.postSubmit();
    this.formArea.reset();
    this.formArea.get('descricao').setValue('');
    this.formArea.get('cliente').setValue('');
    this.formArea.get('centroCusto').setValue('');
    this.formArea.get('endereco').setValue('');
    this.formArea.get('tipoCadastroArea').setValue('');
    this.formArea.get('unidadeGestora').setValue('');
    this.formArea.get('sigla').setValue('');
    this.formArea.get('ativo').setValue(true);
    this.formArea.get('areaPadrao').setValue(false);
    this.formArea.get('codAutomatico').setValue(false);
  }

  getDadosAreaEdit(area: AreaModel) {
    this.area = { ...area };
    this.formArea.get('descricao').setValue(area.descricao);
    this.formArea.get('cliente').setValue(area.cliente);

  }

  confirmeExclusao(areExclusao: AreaModel) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: 'Deseja excluir esta Área (Cód: ' + areExclusao.codigo + ') ?',
        from: 'area.component.ts'
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.deleteArea(areExclusao.id);
      }
    });
  }

  clearArrayUsuarios() {
    this.usuariosAuth.splice(0, this.usuariosAuth.length);
  }

  deleteArea(id: number) {
    this.areaService.deleteArea(id).subscribe(area => {
      this.areas.splice(1, id);
      // console.log(this.areas.length);
      if (this.areas.length === 1) {
        this.getAreasIdCliente(this.clientePropId);
      }
      this.openSnackBarSuccess('Área excluída com sucesso !');
    }, err => {
      this.openSnackBarError(err.error.message);
      console.log(err);
    });
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorArea = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorArea = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaArea = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaArea = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  checkValue(event: any) {
    if (event.currentTarget.checked === true) {
      this.areaService.getLastCodigo(this.clienteId).subscribe(data => {
        // tslint:disable-next-line: no-construct
        const codigoAdd: any = new Number(data);
        this.formArea.get('codigo').setValue(codigoAdd + 1);
      }, err => {
        console.error(err);
        this.openSnackBarError('Erro ao tentar gerar o código automático !');
      });
    } else {
      this.formArea.get('codigo').setValue(' ');
    }
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/areas/areas.component.ts